import React from 'react';

// Props interface (optional, can be removed if not needed)
interface SteakIconProps extends React.SVGProps<SVGSVGElement> {}

// The SteakIcon component
const SteakIcon: React.FC<SteakIconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100" // Adjusted viewBox for better scaling
    fill="none" // Use 'none' for the container
    stroke="currentColor" // Use stroke color
    strokeWidth={2} // Default stroke width
    {...props} // Spread other props (e.g., className, style)
  >
    {/* Outer shape of the steak */}
    <path
      d="M20 30 
         C 30 15, 70 15, 80 30 
         Q 90 40, 85 50 
         C 80 65, 60 65, 50 60 
         Q 40 55, 30 60 
         C 20 65, 10 60, 15 50 
         Q 20 40, 20 30 Z"
      fill="#F2C9C9" // Light pink fill for the fat/edge
      stroke="#D99F9F" // Darker pink stroke
    />

    {/* Inner meat part */}
    <path
      d="M25 35 
         C 35 25, 65 25, 75 35 
         Q 85 45, 80 55 
         C 75 70, 55 70, 45 65 
         Q 35 60, 25 65 
         C 15 70, 5 65, 10 55 
         Q 15 45, 25 35 Z"
      fill="#D93636" // Red fill for the meat
      stroke="#A62929" // Darker red stroke
    />

    {/* Bone/fat circle */}
    <circle
      cx="60"
      cy="40"
      r="8"
      fill="#FCECEC" // Very light pink fill for the bone/fat
      stroke="#E6BDBD" // Light pink stroke
    />
  </svg>
);

export default SteakIcon;